import { yen, paymentLabel } from "../lib/api";
import { useStore } from "../lib/store";

const line = "--------------------------------";

export const ThermalReceipt = ({ order }) => {
  const { storeName, address, phone } = useStore();
  if (!order) return null;
  return (
    <div id="thermal-receipt">
      <div style={{ textAlign: "center" }}>
        <div style={{ fontWeight: "bold", fontSize: 12 }}>{storeName.toUpperCase()}</div>
        <div>{address}</div>
        <div>Tel {phone}</div>
      </div>
      <div>{line}</div>
      <div>No : {order.order_no}</div>
      <div>
        Tgl: {new Date(order.paid_at || order.created_at).toLocaleString("ja-JP")}
      </div>
      <div>
        Tipe: {order.order_type === "dine_in" ? `Resto ${order.table_name || ""}` : "Retail"}
      </div>
      <div>{line}</div>
      {order.items.map((it, i) => (
        <div key={it.product_id || `${it.name}-${i}`}>
          <div>{it.name}</div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>
              {it.qty} x {yen(it.price)}
            </span>
            <span>{yen(it.price * it.qty)}</span>
          </div>
        </div>
      ))}
      <div>{line}</div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>Subtotal</span>
        <span>{yen(order.subtotal)}</span>
      </div>
      {order.discount > 0 && (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>Diskon</span>
          <span>-{yen(order.discount)}</span>
        </div>
      )}
      <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" }}>
        <span>TOTAL</span>
        <span>{yen(order.total)}</span>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>{paymentLabel(order.payment_method)}</span>
        <span>{yen(order.paid_amount)}</span>
      </div>
      {order.change > 0 && (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>Kembali</span>
          <span>{yen(order.change)}</span>
        </div>
      )}
      <div>{line}</div>
      <div style={{ textAlign: "center" }}>
        Terima kasih atas kunjungan Anda
        <br />
        ありがとうございました
      </div>
    </div>
  );
};
